var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLockIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "interface-lock--combination-combo-lock-locked-padlock-secure-security-shield-keyhole"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 5,
    fill: "#169A52"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.7146 7.85706H4.28599C3.49702 7.85706 2.85742 8.49665 2.85742 9.28563V17.8571C2.85742 18.646 3.49702 19.2856 4.28599 19.2856H15.7146C16.5035 19.2856 17.1431 18.646 17.1431 17.8571V9.28563C17.1431 8.49665 16.5035 7.85706 15.7146 7.85706Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15 7.85709V5.71423C15 4.38815 14.4732 3.11638 13.5355 2.1787C12.5979 1.24102 11.3261 0.714233 10 0.714233C8.67392 0.714233 7.40215 1.24102 6.46447 2.1787C5.52678 3.11638 5 4.38815 5 5.71423V7.85709",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.0004 14.2856C10.3949 14.2856 10.7147 13.9658 10.7147 13.5713C10.7147 13.1769 10.3949 12.8571 10.0004 12.8571C9.60593 12.8571 9.28613 13.1769 9.28613 13.5713C9.28613 13.9658 9.60593 14.2856 10.0004 14.2856Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLockIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lock_icon.e92dcaf54464e13a2666dc8773c2bc43.svg";